<template>
  <div>
    <div v-if="!onChild">
      <tableTitle>转户基本详情</tableTitle>
      <Form ref="formValidate" :label-width="125" style="margin:30px" inline>
        <FormItem label="转户ID">
          <Input :value="deliverInfo.id" style="width: 150px;" readonly />
        </FormItem>
        <br>
        <FormItem label="转出方">
          <dict-select :value="deliverInfo.deliverOutLeaseeId" namespace="bizObjects" id="member" :exclusion="[]" style="width: 150px;" disabled />
        </FormItem>
        <FormItem label="接收方">
          <dict-select :value="deliverInfo.deliverInLeaseeId" namespace="bizObjects" id="member" :exclusion="[]" style="width: 150px;" disabled />
        </FormItem>
        <br>
        <FormItem label="标的物小类">
          <dict-select :value="deliverInfo.targetType" namespace="target" id="type" :exclusion="[]" style="width: 150px;" disabled />
        </FormItem>
        <FormItem label="转户数量">
          <Input v-model="deliverInfo.amount" style="width: 150px;" disabled />
        </FormItem>
        <br>
        <FormItem label="转户协议">
          <Input v-model="deliverInfo.deliverAgreementCode" style="width: 150px;" disabled />
        </FormItem>
        <FormItem label="状态">
          <dict-select :value="deliverInfo.status" namespace="ENUM_MID-OPERATE-LEASE" id="deliver.DeliverStatus" :exclusion="[]" style="width: 150px;" disabled />
        </FormItem>
        <br>
        <FormItem label="转出时间">
          <DatePicker :value="deliverInfo.deliverOutDate" type="date" style="width: 200px" disabled></DatePicker>
        </FormItem>
        <br />
        <FormItem label="备注信息">
          <Input v-model="deliverInfo.remark" type="textarea" style="width:490px" disabled />
        </FormItem>
      </Form>

      <tableTitle>附件列表</tableTitle>
      <a v-for="(item,index) in imgList" :key="index" style="padding-left:20px" class="hoverCollection" @click="onDownloadFile(pltUtil.downloadUrl()+item.id)" title="点击下载该附件！">{{item.originFileName}}</a>

      <tableTitle>操作选项</tableTitle>
      <Form ref="action" :label-width="125" style="margin:30px" inline>
        <FormItem label="确认结果">
          <dict-select v-model="action.result" namespace="ENUM_MID-OPERATE-LEASE" id="deliverService.Result" :exclusion="[]" style="width: 150px;" />
        </FormItem>
        <div v-if="action.result=='RECIEVE'">
          <div style="margin-left:55px;margin-bottom:10px;color:red">接收日期允许范围为: 转出日起 至 转出{{days}}天后(不晚于当前日期).如需选择其他时间请联系运营</div>
          <FormItem label="接收时间">
            <DatePicker type="date" :options="options" placeholder="请选择" style="width: 200px" @on-change="(val)=>action.recieveDate = val"></DatePicker>
          </FormItem>
          <FormItem label="框架协议号：">
            <Select v-model="action.frameRentId" style="width:200px" filterable clearable label-in-value :disabled="appointed" @on-change="onFrameChange">
              <Option v-for="item in frameRentList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem v-if="rentTermShow" label="约定期限：" prop="rentTerm">
            <InputNumber :min="1" style="width:200px" :disabled="!rentTermEdit" v-model="action.rentTerm" />
          </FormItem>
          <Button type="success" @click="goDetail" :disabled="!action.frameRentId" size="small">查看协议详情</Button><br>
          <FormItem label="责任分区" v-if="deliverInfo.deliverInLeaseeId">
            <bizSelect v-model="action.groupFlag" url="http://CORE-MEMBER/messageService/respZoneService/queryRespZoneByMemberId" :params="{memberId:deliverInfo.deliverInLeaseeId}" codeField="respZoneId" style="width:200px" />
          </FormItem>
        </div>
        <FormItem label="操作说明">
          <Input v-model="action.confirmRemark" maxlength="100" show-word-limit type="textarea" style="width: 200px" />
        </FormItem>
      </Form>

      <div style="text-align:center;width:700px;margin:30px">
        <Button type="primary" style="margin-left:20px" @click="commit">提交</Button>
        <Button type="warning" style="margin-left:20px" @click="back">返回</Button>
      </div>
      <preview-image ref="previewImageRef" />

    </div>

    <div v-if="onChild">
      <frameworkAgreeDetail :paramsData="currentParams" @onFinish="onChild=false"></frameworkAgreeDetail>
    </div>
  </div>
</template>

<script>
import dictSelect from "@/components/select/dict-select.vue";
import bizSelect from "@/components/select/biz-select.vue";

import tableTitle from "@/components/tableTitle/tableTitle.vue";
import frameworkAgreeDetail from "@/views/user-center/lease/leaseList/frameworkAgreeDetail.vue";
export default {
  components: {
    dictSelect,
    tableTitle,
    frameworkAgreeDetail,
    bizSelect
  },
  props: ["deliverInfo"],
  data() {
    return {
      onChild: false,
      currentParams: {},
      action: {},
      frameRentList: [],
      appointed: false,
      rentTermShow: false,
      rentTermEdit: false,
      days: 2, //下游允许延迟接收的天数
      options: {
        disabledDate: (date) => {
          let st = this.deliverInfo.deliverOutDate;
          let days = this.days;
          st = st + " 00:00:00";
          let invalidDate = new Date(st).valueOf();
          let invalidDate2 = invalidDate + days * 24 * 60 * 60 * 1000;
          return (
            date &&
            (date.valueOf() < invalidDate || date.valueOf() > invalidDate2 || date.valueOf() > new Date().valueOf())
          );
          // return date && date.valueOf() < invalidDate;
        },
      },
      imgList: [],
    };
  },
  mounted() {
    this.action.deliverId = this.deliverInfo.id;
    this.queryFrameRent();
    this.queryDaysForReceiver(
      this.deliverInfo.deliverOutLeaseeId,
      this.deliverInfo.deliverInLeaseeId
    );
    if (this.deliverInfo.deliverAgreementCode) {
      this.queryFrameTrans();
    }
    if (this.deliverInfo.documentId) {
      this.queryImgList();
    }
  },
  methods: {
    onDownloadFile(url) {
      var tempwindow = window.open("_blank");
      tempwindow.location = `${url}&disposition=inline`;
    },
    goDetail() {
      this.currentParams = this.action.frameRentId;
      this.onChild = true;
    },
    queryDaysForReceiver(fromMemberId, toMemberId) {
      let params = {
        url: "http://MID-OPERATE-LEASE/messageService/deliverService/queryDaysForReceiver",
        body: {
          fromMemberId: fromMemberId,
          toMemberId: toMemberId,
        },
      };
      this.invoke(params).then((rs) => {
        if (rs) {
          this.days = rs;
        }
      });
    },
    queryImgList() {
      let params = {
        url: "http://MID-TECH-IMAGE/messageService/documentService/queryDocument",
        body: {
          id: this.deliverInfo.documentId,
        },
      };
      this.invoke(params).then((rs) => {
        if (rs) {
          this.imgList = rs.files;
        }
      });
    },
    async queryFrameRent() {
      this.frameRentList = [];
      let data = {
        url: "CORE-CONTRACT/messageService/queryService/queryFrameRentListByCondition",
        body: {
          memberId: this.deliverInfo.deliverInLeaseeId,
          targetType: this.deliverInfo.targetType,
        },
      };
      this.frameRentList = await this.invoke(data);
    },
    queryFrameTrans() {
      let params = {
        url: "CORE-CONTRACT/messageService/billingModelService/queryFrameTransEntityByFrameId",
        body: { frameId: this.deliverInfo.deliverAgreementCode },
      };
      this.invoke(params).then((rs) => {
        if (rs.appointFrameRent) {
          this.action.frameRentId = rs.appointFrameRent;
          this.appointed = true;
          this.onFrameChange({ value: rs.appointFrameRent });
        }
      });
    },
    onFrameChange(val) {
      // this.action.frameRentId = val.value
      this.action.rentTerm = "";
      if (!val.value) {
        this.rentTermShow = false;
        return;
      }
      this.frameRentList.forEach((item) => {
        if (val.value === item.id) {
          if (item.modelId === "06") {
            //随心托
            this.rentTermShow = false;
          } else {
            this.rentTermShow = true;
            if (item.rentTerm) {
              this.action.rentTerm = item.rentTerm;
              this.rentTermEdit = false;
            } else {
              this.rentTermEdit = true;
            }
          }
        }
      });
    },
    async commit() {
      await this.showConfirm();
      let params = {
        url: "http://MID-OPERATE-LEASE/messageService/deliverService/confirmDeliverOrder",
        body: this.action,
      };
      this.invoke(params).then((rs) => {
        if (rs) {
          this.$Message.info("提交成功!");
          this.back();
          this.action.groupFlag = "";
        }
      });
    },
    back() {
      this.$emit("on-finish", {});
    },
  },
};
</script>